import { Button, Form, Input, message, Modal, Radio, Spin } from 'antd';

import React from 'react'
import { post } from '../../../axios';
import { API_open_home_sendVerifyCode } from '../../../axios/config';
import {
    fetchAccountingRecordConfirmationProcess,
    fetchAccountingRecordConfirmationSendVerifyCode
} from '../../../services/accountingRecord';
import { handleExportParams } from '../../../utils';
import { isPhone } from "../../../utils/validate";


class MerchantConfirmProcessModal extends React.Component{
    constructor() {
        super();
        this.state = {
          visible: false,
          loading: false,
          formData: {},
          codeTime: 0,
        };
      }
  
    componentWillUnmount() {
        clearTimeout(this.timer)
    }
    open = (accountingRecordLogId) => {
        this.accountingRecordLogId = accountingRecordLogId
        this.setState({ visible: true });
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject }
        })
    };

    close = () => {
        this.setState({ visible: false, formData: {} });
    };
    getLoginPhone() {
        return handleExportParams().phone
    }

    getLegalPersonPhone(){
        return handleExportParams().legalPersonPhone
    }

    checkFormData = (data) => {
        if (!data.verifyCode) return message.warn('请输入验证码')
        if (!data.status) return message.warn('请选择状态')
        if (data.status === 5 && !data.remarks) return message.warn('请输入备注')
        return true
    }

    handleChange = (e,key) => {
        const { value } = e.target
        this.setState(state => {
            state.formData[key] = value
            return state
        })
    }
    setCodeTimeout() {
        if (this.state.codeTime === 0) {
            this.setState({ codeTime : 60 })
            setTimeout(() =>this.setCodeTimeout(),1000)
        } else {
            this.setState({ codeTime : this.state.codeTime -1 }, () => {
                this.state.codeTime > 0 && setTimeout(() =>this.setCodeTimeout(),1000)
            })
        }
    }

    handleCodeGet = () => {
        const phone = this.getLoginPhone()
        if (!phone) return message.warn('请输入手机号')
        if (!isPhone(phone)) return message.warn('请输入正确的手机号')
        this.setCodeTimeout()

        this.postPhoneCodeGet(phone)
    }

    handleOk = () => {
        if (this.checkFormData(this.state.formData) !== true) return
        this.postConfirmationProcess().then(() => {
            this.close()
            this.monitor.resolve()
        })
    }

    postPhoneCodeGet() {
        return fetchAccountingRecordConfirmationSendVerifyCode().then(() => {
           // message.success('操作成功')
        }).finally(() => {
            this.setState({loading: false})
        })
    }
    postConfirmationProcess() {
        const data = {
            ...this.state.formData,
            accountingRecordLogId: this.accountingRecordLogId
        }
        this.setState({ loading: true })
        return fetchAccountingRecordConfirmationProcess(data).then(() => {
            message.success('操作成功')
        }).finally(()=>{
            this.setState({ loading: false })
        })
    }
    render(){
        const loading = !!this.state.loading
        const { codeTime } = this.state
        return (
           <Modal title="验证" visible={this.state.visible} onOk={this.handleOk} onCancel={this.close} confirmLoading={loading}>
               <Spin spinning={loading}>
                    <Form style={{padding: 20}} ref={ref => this.FormRef = ref}>
                        <Form.Item required label="手机号">
                            <Input disabled  value={this.getLoginPhone()} />
                        </Form.Item>
                        <Form.Item required label="验证码">
                            <div style={{display: 'flex'}}>
                                <Input onChange={(e) => this.handleChange(e, 'verifyCode')} value={this.state.formData.verifyCode} />
                                <Button disabled={codeTime > 0} style={{marginLeft: 10}} onClick={this.handleCodeGet}>
                                    {codeTime === 0 ? '获取验证码' : (codeTime + 's')}
                                </Button>
                            </div>
                        </Form.Item>
                        <Form.Item required label="审核">
                            <Radio.Group onChange={(e) => this.handleChange(e, 'status')} value={this.state.formData.status}>
                                <Radio value={3}>通过</Radio>
                                <Radio value={5}>驳回</Radio>
                            </Radio.Group>
                        </Form.Item>
                        { this.state.formData.status === 5 && (
                            <Form.Item required label="备注">
                                <Input.TextArea onChange={(e) => this.handleChange(e, 'remarks')} value={this.state.formData.remarks}  />
                            </Form.Item>
                        )}
                    </Form>
                </Spin>
           </Modal>
        )
    }
}

export default MerchantConfirmProcessModal


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/MerchantConfirmProcessModal.jsx